export const GG_RANKS_REGULAR = ['Spieler', 'Premium', 'Ultra', 'Titan', 'Legende', 'Griefer', 'Supreme', 'Hero'] as const;

export const GG_RANKS_SPECIAL = ['Youtuber', 'YoutuberPlus', 'Streamer', 'StreamerPlus', 'Freund'] as const;

export const GG_RANKS_TEAM = ['Helfer', 'Supporter', 'Moderator', 'Content', 'SrContent', 'Developer', 'SrDeveloper', 'Admin', 'Owner'] as const;

// Matches GGRangExtensions.GetDisplayName: the two plus-ranks are the only names that differ from
// the enum spelling. Rank names are GrieferGames proper nouns and stay untranslated.
export function ggRankLabel(rank: string): string {
    if (rank === 'YoutuberPlus') return 'Youtuber+';
    if (rank === 'StreamerPlus') return 'Streamer+';
    return rank;
}
